'use client';

import React from 'react';

import {
    Section,
    Spacer,
    SpacerSize,
    Text,
    Title,
    TitleLevels,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

import { FaqType } from '@app-types/faq';
import { ProductParentFull } from '@app-types/product';

import { isFirstLetterVowel } from '@helpers/wording';

export type FaqProps = {
    product: ProductParentFull;
    faq: FaqType;
};

export function Faq({ product, faq }: Readonly<FaqProps>) {
    const { name } = product;
    const definiteArticle = isFirstLetterVowel(name) ? "l'" : 'le ';

    return (
        <>
            <Title level={TitleLevels.FOUR}>
                Vos questions sur {definiteArticle}
                {name}
            </Title>
            <Section backgroundColor={TrilogyColor.BACKGROUND}>
                {faq.map(({ question, answer }) => (
                    <div key={question}>
                        <Text marginless typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                            {question}
                        </Text>
                        <Text>{answer}</Text>
                        <Spacer size={SpacerSize.FOUR} />
                    </div>
                ))}
            </Section>
        </>
    );
}
